// PdfPreviewModal.jsx
import React, { useEffect, useMemo } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

// React PDF Viewer (core + default layout)
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import es_ES from '@react-pdf-viewer/locales/lib/es_ES.json';

const useDefaultLayout = fileName =>
	defaultLayoutPlugin({
		toolbarPlugin: {
			getFilePlugin: {
				fileNameGenerator: openFile => {
					// Si el visor conoce el nombre, lo usa; si no, ocupa el título recibido
					const base = (fileName || openFile?.name || 'documento').replace(
						/\.pdf$/i,
						''
					);
					return `${base}.pdf`;
				},
			},
		},
	});

const PdfPreviewModal = ({
	isOpen,
	onClose,
	blob, // <- tu Blob
	title = 'Vista previa PDF',
}) => {
	// Crear un Object URL para el blob (y limpiarlo después)
	const fileUrl = useMemo(
		() => (blob ? URL.createObjectURL(blob) : undefined),
		[blob]
	);
	useEffect(
		() => () => {
			if (fileUrl) URL.revokeObjectURL(fileUrl);
		},
		[fileUrl]
	);

	// Instancia del layout con descarga personalizada
	const defaultLayoutPluginInstance = useDefaultLayout(title);

	return (
		<Modal
			isOpen={isOpen}
			toggle={onClose}
			size='xl'
			style={{ maxWidth: '90%' }}
		>
			<ModalHeader toggle={onClose}>{title}</ModalHeader>

			<ModalBody
				style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
			>
				{!blob ? (
					<div
						className='text-center w-100'
						style={{ alignSelf: 'center' }}
					>
						Cargando PDF…
					</div>
				) : (
					// Configura el worker de pdf.js (debe coincidir con la versión instalada)
					<Worker workerUrl='https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js'>
						<div
							style={{
								border: '1px solid rgba(0,0,0,0.1)',
								borderRadius: 8,
								height: '75vh',
								width: '100%',
								overflow: 'hidden',
							}}
						>
							<Viewer
								fileUrl={fileUrl} // <- pasamos el Object URL
								plugins={[defaultLayoutPluginInstance]} // <- toolbar + sidebar + etc.
								localization={es_ES}
							/>
						</div>
					</Worker>
				)}
			</ModalBody>
		</Modal>
	);
};

export default PdfPreviewModal;
